<template>
  <div>
    <h1>What's your nickname?</h1>
    <input type="text" placeholder="My nick name" v-model="newMe.name" />
    <label for="agree"><input id="agree" name="agree" type="checkbox" v-model="newMe.agree"> Agree our Terms</label>
    <span class="linker" @click="showPrivacy = !showPrivacy">Read our Privacy Statement</span>
    <br />
    <button @click="setNewMe">Submit</button>
    <br />
    <div v-if="msgs.length > 0" >
      <div class="red" :key="msg.id" v-for="msg in msgs">{{ msg.msg }}</div>
    </div>

    <pre v-if="debug">{{ Status.state }}</pre>
    <div class="privacy-area" v-if="showPrivacy">
      <Privacy>
      </Privacy>
    </div>
  </div>
</template>

<script>
import Privacy from './Privacy.vue'
import { Status } from '@/yoteach2-gui/parts/YoNetwork/YoNetwork.js'
export default {
  components: {
    Privacy
  },
  props: {
    debug: {
      default: false
    }
  },
  data () {
    return {
      showPrivacy: false,
      Status,
      newMe: {
        name: '',
        agree: false
      },
      msgs: []
    }
  },
  methods: {
    setNewMe () {
      this.msgs = []
      if (!this.newMe.agree) {
        if (this.msgs.findIndex(m => m.id === 0) === -1) {
          this.msgs.push({ id: 0, msg: 'Needs to agree our terms.' })
        }
      }
      if (!this.newMe.name.trim()) {
        if (this.msgs.findIndex(m => m.id === 1) === -1) {
          this.msgs.push({ id: 1, msg: 'Needs to fill in your nickname.' })
        }
      }

      if (this.msgs.length > 0) {
        return
      }

      let info = JSON.parse(JSON.stringify(this.newMe))
      delete info.agree
      Status.setChatter({ chatter: info })
      this.$emit('ready')
      this.msgs = []
    }
  }
}
</script>

<style scoped>
.privacy{
  white-space: pre-wrap;
}
.disclaimer{
  white-space: pre-wrap;
}
.red{
  color: red;
}

.linker{
  color: blue;
  text-decoration: underline;
}
</style>
